import React from 'react';
import { motion } from 'framer-motion';
export function TriggerMoment() {
  return <section className="bg-[#FAFAF8] py-20 md:py-28" data-id="element-447">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto px-6" data-id="element-448">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] tracking-tight mb-10" data-id="element-449">
          The Trigger Moment
        </h2>

        <div className="space-y-6 text-lg text-[#4B5563] leading-relaxed" data-id="element-450">
          <p data-id="element-451">You already know the feeling.</p>
          <p data-id="element-452">
            A gust of wind and your hand goes straight to your head. A photo
            from above and you're scanning your crown before you even see anyone
            else's face. You avoid certain lighting. You've started wearing hats
            you never used to wear.
          </p>
          <p data-id="element-453">
            You've looked into the options — finasteride, minoxidil, laser caps.
            Your reaction to all of them has been some version of the same
            thought:
          </p>

          <p className="text-xl md:text-2xl italic text-[#1A1A1A] font-medium py-4" data-id="element-454">
            "If there was something that actually worked, everyone would know
            about it by now."
          </p>

          <p data-id="element-455">That skepticism is rational. You've been right to be cautious.</p>
          <p data-id="element-456">
            But there's one piece of the puzzle you likely haven't been shown —
            and it changes the equation.
          </p>
        </div>
      </motion.div>

      {/* Divider */}
      <div className="max-w-6xl mx-auto px-6 mt-20" data-id="element-457">
        <div className="h-px bg-gray-200" data-id="element-458" />
      </div>
    </section>;
}